import { FavyColumns } from "./FavyColumns";
import { ThemeContext, TRUSTPILOT_REVIEW_WIDGET } from "./ThemeContext";

export const FavyColumnsTrustpilot = (props) => (
	<ThemeContext.Provider
		value={{ reviewWidget: TRUSTPILOT_REVIEW_WIDGET, ...props }}
	>
		<FavyColumns {...props} />
	</ThemeContext.Provider>
);
